import type { CrmCustomFiltersDescription } from "app/pages/sales-intelligence/domain/crm-integration/types/custom-filter-options";
import type {
    CrmRecordsParams,
    CrmRecordsResponseDto,
} from "app/pages/sales-intelligence/domain/crm-integration/types/records";
import type { GetRequestOptions, IFetchService, PostConfigObject } from "app/services/fetchService";

const createCrmIntegrationApiService = (fetchService: IFetchService) => {
    return {
        fetchCrmCustomFiltersDescription(options?: Readonly<GetRequestOptions>): Promise<CrmCustomFiltersDescription> {
            return fetchService.get(
                "/sales-api/advanced-search/description/integration-custom-filters",
                undefined,
                options,
            );
        },

        fetchCompanyCrmRecords(
            { domain, dto, integrationProvider }: CrmRecordsParams,
            config?: PostConfigObject,
        ): Promise<CrmRecordsResponseDto> {
            return fetchService.post(
                `sales-api/advanced-search/companies/${domain}/${integrationProvider}/records`,
                dto,
                config,
            );
        },
    };
};

export default createCrmIntegrationApiService;
